import { render, staticRenderFns } from "./CargarDocumento.vue?vue&type=template&id=1e020f34&"
import script from "./CargarDocumento.vue?vue&type=script&lang=js&"
export * from "./CargarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports